export const navigationHeaderRootId = 'navigation-header-root';

export const mobileHeaderContainerId = 'navigation-header-mobile-container';
export const mobileMenuDropdownId = 'navigation-header-menu-dropdown';
export const mobileMenuButtonId = 'navigation-header-menu-button';

export const desktopSmallHeaderContainerId =
  'navigation-header-desktop-small-container';
export const desktopLargeHeaderContainerId =
  'navigation-header-desktop-large-container';
export const desktopHeaderProfileDropdownMenuId =
  'navigation-header-desktop-profile-dropdown-menu';
export const desktopHeaderActivatableNavButtonDataAttr =
  'navigation-header-activatable-nav-button';
export const desktopHeaderProfileButtonId =
  'navigation-header-desktop-profile-button';

export const dropdownStateDataAttr = 'navigation-header-dropdown-open';
export const dropdownGenericCloseDataAttr =
  'navigation-header-dropdown-close-action';

export const getLoginNavButtonProps = (href: string) => ({
  href,
  'data-navigation-header-login-nav-button-base-href': href,
});

export const deviceSectionTestIds = {
  mobile: 'mobile-navigation-header',
  desktopSmall: 'desktop-small-navigation-header',
  desktopLarge: 'desktop-large-navigation-header',
};

export const navHeaderBannerIds = {
  mobile: 'navigation-header-banner-mobile',
  desktopSmall: 'navigation-header-banner-desktop-small',
  desktopLarge: 'navigation-header-banner-desktop-large',
};

export const navLinkIds = {
  homeLogo: 'navbar-nav-item-logo',
  home: 'navbar-nav-item-buy-a-business',
  sellABusiness: 'navbar-nav-item-sell-a-business',
  sellABusinessButton: 'navbar-nav-item-sell-a-business-button',
  franchise: 'navbar-nav-item-franchise',
  findBrokers: 'navbar-nav-item-brokers',
  adviceAndTips: 'navbar-nav-item-blog',
  signIn: 'navbar-nav-item-sign-in',
  signOut: 'navbar-nav-item-sign-out',
  register: 'navbar-nav-item-register',
  buyerPreferences: 'navbar-nav-item-buyer-preferences',
  advertisers: 'navbar-nav-item-advertisers',
  advertiseWithUs: 'navbar-nav-item-advertise-with-us',
  myProfile: 'navbar-nav-item-my-profile',
  savedBusinesses: 'navbar-nav-item-saved-businesses',
  savedSearches: 'navbar-nav-item-saved-searches',
  businessSearch: 'navbar-nav-item-business-search',
  advertiserCentre: 'navbar-nav-item-advertiser-centre',
  buyABusiness: 'navbar-nav-item-buy-a-business',
};

export const createNavLinks = (baseUrl: string) => {
  const getExternalLink = (href: string) => `${baseUrl}${href}`;

  const signOutSearchParams = new URLSearchParams();
  signOutSearchParams.set('returnPath', '/sign-out?returnurl=/');

  return {
    home: getExternalLink('/'),
    sellABusiness: getExternalLink('/private-seller-info'),
    businessesForSale: getExternalLink('/businesses-for-sale'),
    franchise: '/franchises-licensing-distribution',
    findBrokers: getExternalLink('/business-brokers-directory'),
    adviceAndTips: getExternalLink('/business-resources'),
    signIn: getExternalLink('/sign-in'),
    signOut: getExternalLink(`/oauth/logout/?${signOutSearchParams}`),
    register: getExternalLink('/sign-up'),
    buyerPreferences: '/buyer/preferences',
    advertisers: getExternalLink('/private-seller-info'),
    myProfile: '/profile/my-details',
    savedBusinesses: '/profile/saved-businesses',
    savedSearches: '/profile/saved-searches',
  };
};
